import React, { useEffect, useState, useMemo } from "react";

import moment from "moment";
import useHttp from "../../hooks/use-http";

const AgriPromoterDashborad = () => {
  const [data, setData] = useState([]);
  const [landData, setLandData] = useState([]);
  const [cropData, setCropData] = useState([]);
  const [cropArea, setCropArea] = useState(0);
  
  const [weatherData, setWeatherData] = useState("");
  const [currentDay, setCurrentDay] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [todaysHarvest, setTodaysHarvest] = useState([]);

  const [totalAgroPromoter, setTotalAgroPromoter] = useState(0);
  const [todaysSales, setTodaysSales] = useState(0);
  const [todaysTraining, setTodaysTraining] = useState(0);
  const [todaysDemo, setTodaysDemo] = useState(0);
  const [targetData, setTargetData] = useState(0);
  

  

  const { sendRequest: getData } = useHttp();

  useEffect(() => {
    getData(
      {
        url: `/api/agriPromoterWebDashboard/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        console.log(res);
        if (res)
        {
          console.log(res["totalAgroPromoter"]);
           setTotalAgroPromoter(res["totalAgroPromoter"]) ;
           setTodaysSales(res["todaysSales"])
           setTodaysTraining(res["todaysTraining"])
           setTodaysDemo(res["todaysDemo"])
           setTargetData(res["targetData"])
                 
        }

   
      }
    );
  }, [getData]);
  
  return (
    <>
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>

              <div className="col-sm-6"></div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-3">
                <div className="info-box bg-success">
                  <div className="info-box-content">
                    {totalAgroPromoter}
                    <label className="info-box-">No of Agro Promoter</label>
                    {/* <div className="row text-center">
                      <div className="col-12 col-sm-12 col-md-6">
                        Farmer <br /> <label>{data && data.farmerCount}</label>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        Area <br />
                        <label>
                          {landData && landData.totalLand} {landData.landUnit}
                        </label>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-3">
                <div className="info-box mb-3 bg-success">
                  <div className="info-box-content">
                  {todaysSales}
                    <label className="info-box-text">Total Sales</label>
                    {/* <div className="row text-center">
                    <div className="col-12 col-sm-12 col-md-6">
                      Sown <br />{" "}
                      <label>
                        {parseFloat(cropArea).toFixed(2)}{" "}
                        {(cropData[0] && cropData[0].unitAbbreviation) || ""}
                      </label>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                      Crops <br />
                      <label>{cropData && cropData.length}</label>
                    </div>
                  </div>
                  <div className="crop-progress-bar">
                    <div className="progress-bar-fill">
                      {cropData.map((crop) => (
                        <span
                          key={crop.cropName}
                          style={{
                            width: `${(crop.totalArea / cropArea) * 100}%`,
                            backgroundColor: getColor(crop),
                          }}
                          title={`${crop.cropName} - ${crop.totalArea} ${crop.unitAbbreviation}`}
                        ></span>
                      ))}
                    </div>

                    {cropData.map((crop) => (
                      <p key={crop.cropName} style={{ marginBottom: "-5px" }}>
                        <span
                          style={{
                            backgroundColor: getColor(crop),
                            width: "10px",
                            height: "10px",
                            display: "inline-block",
                            marginRight: "5px", // Adjust the spacing between the dot and crop name as needed
                            borderRadius: "50%", // Make the dot circular
                          }}
                        />
                        {`${crop.cropName}`}
                      </p>
                    ))}
                  </div> */}
                  </div>
                </div>
              </div>

              <div className="clearfix hidden-md-up" />
              <div className="col-12 col-sm-6 col-md-3">
                <div className="info-box mb-3 bg-success">
                  <div className="info-box-content">
                  {todaysTraining}
                    <label className="info-box-text">Today's Training</label>
                  </div>
                </div>
              </div>

              <div className="clearfix hidden-md-up" />
              <div className="col-12 col-sm-6 col-md-3">
                <div className="info-box mb-3 bg-success">
                  <div className="info-box-content">
                    {todaysDemo}
                    <label className="info-box-text">Todays Demo</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              <div className="info-box mb-3 bg-info">
                <div className="info-box-content">
                  <label className="info-box-text"></label>
                  <div className="row">
                    <div className="col-12"> 
                      <div className="table-responsive agri-dash" style={{ maxHeight: '350px', overflowY: 'auto', paddingRight: '10px' }}>
                        <table className="table table-bordered text-center">
                          <thead>
                            <tr>
                              <th>Agri Promoter </th>
                              <th>From Date</th>
                              <th>To Date</th>
                              <th>Target Demo</th>
                              <th>Actual Demo</th>
                              <th>Total Sales</th>
                            </tr>
                          </thead>
                          <tbody>                             
                            {targetData &&
                              targetData.map((x, i) => (
                                <tr key={i}>
                                  <td>{x.employeeName}</td>
                                  <td>{x.fromDate}</td>
                                  <td>{x.toDate}</td>
                                  <td>
                                    {x.noOfDemoTobeEstablished} 
                                  </td>
                                  <td>{x.actualNoOfDemo}</td>
                                  <td>{x.totalSales}</td>
                                </tr>
                                
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgriPromoterDashborad;
